var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRfqhome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.177 7.713 16.29 1.817A6.17 6.17 0 0 0 11.612.008L5.114.321A5.025 5.025 0 0 0 .318 5.097l-.312 6.507a6.236 6.236 0 0 0 1.807 4.685L7.7 22.184c2.417 2.421 6.342 2.421 8.772 0l5.705-5.713c2.43-2.407 2.43-6.338 0-8.758zM8.753 12.502A3.755 3.755 0 0 1 5.01 8.754c0-2.07 1.69-3.748 3.743-3.748a3.755 3.755 0 0 1 3.742 3.748c0 2.07-1.69 3.748-3.742 3.748zm10.435 1.497-5.198 5.205a.963.963 0 0 1-.689.287.963.963 0 0 1-.689-.287.983.983 0 0 1 0-1.38l5.199-5.205a.98.98 0 0 1 1.377 0 .983.983 0 0 1 0 1.38z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 7.059,
    y1: 4.588,
    x2: 22.408,
    y2: 20.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48AFCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqhome);
export default __webpack_public_path__ + "static/media/rfq home.349084299c463bbeeaa9b091464b6999.svg";
export { ForwardRef as ReactComponent };